import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Modal } from '@/components/ui/Modal'
import { updateRepairOrder } from '@/services/repairOrders.service'
import { toast } from '@/utils/helpers'

/**
 *
 * MarkInternalModal
 *
 * WARP-957: take an open RO off the Outstanding List as Internal — handled inside the
 * dealership, never sent to the OEM. Terminal, so it asks first. Offered only for an RO
 * still open in the DMS; the API refuses anything else.
 */
const MarkInternalModal = ({ isOpen, setIsOpen, repairOrderId, dealerId }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  return (
    <Modal
      open={isOpen}
      setOpen={setIsOpen}
      title="Mark as Internal"
      loading={loading}
      content={
        <p className="text-charcoal-700 mt-4 text-sm">
          The dealership is handling this repair order itself, so it will not be submitted. It
          comes off the Outstanding List and counts under Internal on the dashboard.
        </p>
      }
      actions={[
        {
          type: 'submit',
          label: 'Mark as Internal',
          onClick: async () => {
            const response = await updateRepairOrder(
              dealerId,
              repairOrderId,
              { markAsInternal: true },
              setLoading,
              (message) => toast(message, 'error'),
            )
            if (!response) return

            setIsOpen(false)
            toast('Repair order marked Internal.', 'success')
            navigate(`/dealer/${dealerId}/detail`)
          },
        },
        { type: 'cancel', label: 'Cancel' },
      ]}
    />
  )
}

MarkInternalModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  repairOrderId: PropTypes.string.isRequired,
  dealerId: PropTypes.string.isRequired,
}

export default MarkInternalModal
